import * as React from 'react';
import { Create, SimpleForm } from 'react-admin';
import { CampaignFormFields, campaignTransform } from './CampaignFormFields';

const CampaignCreate = () => (
    <Create transform={campaignTransform} redirect="edit">
        <SimpleForm>
            <CampaignFormFields />
        </SimpleForm>
    </Create>
);

export default CampaignCreate;
